module.exports = __webpack_public_path__ + "static/media/model3_BackgroundPic.f97a1077.jpg";